module.exports = __webpack_public_path__ + "static/media/Love Life.e6b523ba.jpg";